import React from "react";
import ServicePortfolioDataSocialMediaDesign from "../../../Data/ServicesPageData/ServicePortfolioDataSocialMediaDesign";
import PortfolioTab from "../../PortfolioSections/PortfolioTab";
import SectionTitle2 from "../../Utilities/SectionTitle2";

const ServicePagePortfolio = (props) => {
  const { pageName, servicePagePortfolioProps } = props;
  return (
    <>
      <SectionTitle2
        sectionTitleText={`Fresh from our ${pageName}`}
        sectionCaptionText={`OUR ${pageName} PORTFOLIO`}
      />
      <section id="portfolio" className="portfolio-area mt-5">
        <div className="container">
          <div className="filters-content">
            <PortfolioTab
              data={servicePagePortfolioProps.servicePortfolioData}
              onlyPics={true}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicePagePortfolio;
